module.exports = __webpack_public_path__ + "assets/img/apk_os-env.cb64e2f5.svg";